import { IDealRoomSectionContent } from '@app/interfaces/deal-room';
import { IDealRoomCategory } from '@app/interfaces/deal-room-category';
import { ANY_OBJECT } from '@app/interfaces/interfaces';

export const disabledMenuColumns: Array<ANY_OBJECT> = [
  {
    title: 'dealRooms.selectMenu.section',
    dataIndex: 'label',
    width: 'auto',
    editable: false,
    sorter: (a: IDealRoomSectionContent, b: IDealRoomSectionContent) => (a?.label || '').localeCompare(b?.label || ''),
  },
];

export const categoryColumns: Array<ANY_OBJECT> = [
  {
    title: 'dealRooms.selectMenu.categoryName',
    dataIndex: 'name',
    width: 'auto',
    editable: false,
    sorter: (a: IDealRoomCategory, b: IDealRoomCategory) => (a?.name || '').localeCompare(b?.name || ''),
  },
];
